const requiredDateString = (props, propName, componentName) => {
  const propValue = props[propName];

  if (typeof propValue !== 'string') {
    return new Error(
      `Invalid prop ${propName} supplied to ${componentName}: must be a string date in YYYY-MM-DD format but received value of type '${typeof propValue}'.`
    );
  }

  if (!/^\d\d\d\d-\d\d-\d\d$/.test(propValue)) {
    return new Error(
      `Invalid prop ${propName} supplied to ${componentName}: must be a string date in YYYY-MM-DD format but received '${propValue}'.`
    );
  }
};

const instanceOfDateString = (props, propName, componentName) => {
  if (props[propName] !== null && props[propName] !== undefined) {
    return requiredDateString(props, propName, componentName);
  }
};

instanceOfDateString.isRequired = requiredDateString;

export { instanceOfDateString };
